import { render } from "./self-examination.vue?vue&type=template&id=56fe4cb7&scoped=true"
import script from "./self-examination.vue?vue&type=script&lang=js"
export * from "./self-examination.vue?vue&type=script&lang=js"

import "./self-examination.vue?vue&type=style&index=0&id=56fe4cb7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56fe4cb7"

export default script